import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_SITE_WORK_ORDERS_REFRESH: createSagaAction('JOB_SITE_WORK_ORDERS_REFRESH'),

  JOB_SITE_WORK_ORDER_CREATE: createSagaAction('JOB_SITE_WORK_ORDER_CREATE'),
  JOB_SITE_WORK_ORDER_UPDATE: createSagaAction('JOB_SITE_WORK_ORDER_UPDATE'),
  JOB_SITE_WORK_ORDER_DELETE: createSagaAction('JOB_SITE_WORK_ORDER_DELETE'),

  GET_WORK_ORDER_ITEMS: createSagaAction('GET_WORK_ORDER_ITEMS'),
  MARK_TASK_COMPLETE: createSagaAction('MARK_TASK_COMPLETE'),

  QUICK_ADD_TASK: createSagaAction('QUICK_ADD_TASK')
}

// Action Creators
export const actions = {
  jobSiteWorkOrdersRefresh: ({ jobId, next }) => ({
    type: constants.JOB_SITE_WORK_ORDERS_REFRESH.ACTION,
    jobId,
    next
  }),

  createWorkOrder: ({ jobId, content, workOrderItems, userId }) => ({
    type: constants.JOB_SITE_WORK_ORDER_CREATE.ACTION,
    jobId,
    content,
    workOrderItems,
    userId
  }),

  updateWorkOrder: ({ jobId, workOrderId, userId, content, workOrderItems }) => ({
    type: constants.JOB_SITE_WORK_ORDER_UPDATE.ACTION,
    jobId,
    workOrderId,
    userId,
    content,
    workOrderItems
  }),

  deleteWorkOrder: ({ workOrderId, jobId }) => ({
    type: constants.JOB_SITE_WORK_ORDER_DELETE.ACTION,
    jobId,
    workOrderId
  }),

  getWorkOrderItems: workOrderId => ({
    type: constants.GET_WORK_ORDER_ITEMS.ACTION,
    workOrderId
  }),

  markTaskComplete: ({ jobId, taskId, workOrderId }) => ({
    type: constants.MARK_TASK_COMPLETE.ACTION,
    jobId,
    taskId,
    workOrderId
  }),

  quickAddTask: ({ task, userId }) => ({
    type: constants.QUICK_ADD_TASK.ACTION,
    task,
    userId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_SITE_WORK_ORDERS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_SITE_WORK_ORDERS_REFRESH.SUCCESS:
      return {
        ...state,
        jobSiteWorkOrders: action.payload
      }
    case constants.GET_WORK_ORDER_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_WORK_ORDER_ITEMS.SUCCESS:
      return {
        ...state,
        jobSiteWorkOrdersItems: action.payload
      }
    case constants.JOB_SITE_WORK_ORDERS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_SITE_WORK_ORDER_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_WORK_ORDER_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_WORK_ORDER_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.QUICK_ADD_TASK.SUCCESS:
      return {
        ...state
      }
    case constants.MARK_TASK_COMPLETE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSiteWorkOrderActions.js